module.exports = __webpack_public_path__ + "static/media/idun9.49366a70.JPG";